import { ISvgProps } from '@src/types';

const MuteIcon = ({ width = '38px', height = '38px', color = 'var(--font-color)', ...props }: ISvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} color={color} {...props}>
      <path
        fill="#008AC9"
        transform="translate(0.207031 0.20752)"
        d="M12.3264 0L23.961599 0C30.769283 -1.7763568e-15 36.287998 5.5187173 36.287998 12.3264L36.287998 23.961599C36.287998 30.769283 30.769283 36.287998 23.961599 36.287998L12.3264 36.287998C5.5187173 36.287998 0 30.769283 0 23.961599L0 12.3264C0 5.5187173 5.5187173 0 12.3264 0Z"
        fillRule="evenodd"
      />
      <path
        fill="none"
        stroke="#42444C"
        strokeWidth="0.41472"
        strokeMiterlimit="10"
        transform="translate(0.207031 0.20752)"
        d="M12.3264 0L23.961599 0C30.769283 -1.7763568e-15 36.287998 5.5187173 36.287998 12.3264L36.287998 23.961599C36.287998 30.769283 30.769283 36.287998 23.961599 36.287998L12.3264 36.287998C5.5187173 36.287998 0 30.769283 0 23.961599L0 12.3264C0 5.5187173 5.5187173 0 12.3264 0Z"
        fillRule="evenodd"
      />
      <path
        fill="white"
        transform="matrix(-1 0 0 1 20.2196 17.5635)"
        d="M5.5799479 2.5426857L5.5799479 0L0 5.4032569C0.57256776 5.7810721 1.2635407 6.0023494 2.0068853 6.0023494C3.9771311 6.0023494 5.5799479 4.4504013 5.5799479 2.5426857Z"
      />
      <path
        fill="white"
        transform="matrix(-1 0 0 1 22.5743 18.0377)"
        d="M10.1046 0L9.3929262 0C9.1643963 0 8.9789228 0.17958744 8.9789228 0.40086484L8.9789228 1.8097043C8.9789228 4.275023 6.9074526 6.2809505 4.3611197 6.2809505C3.3977323 6.2809505 2.5024481 5.99333 1.7613808 5.502872L0.67565483 6.5541401C1.5113223 7.1722736 2.5088654 7.5917788 3.5914862 7.7236633L3.5914862 8.721817L0.41400418 8.721817C0.18547387 8.721817 0 8.9014044 0 9.1226816L0 9.811367C0 10.032644 0.18547387 10.212232 0.41400418 10.212232L8.30865 10.212232C8.5371799 10.212232 8.7226534 10.032644 8.7226534 9.811367L8.7226534 9.1226816C8.7226534 8.9014044 8.5371799 8.721817 8.30865 8.721817L5.1309605 8.721817L5.1309605 7.7236633C8.1519489 7.3552685 10.518397 4.7574639 10.518397 1.8097043L10.518397 0.40086484C10.518604 0.17938702 10.33313 0 10.1046 0Z"
      />
      <path
        fill="white"
        transform="matrix(-1 0 0 1 26.338 8.87496)"
        d="M15.91639 1.542127C15.472164 1.1117986 14.750762 1.1117986 14.306535 1.542127L11.698309 4.0675755L11.698309 3.4598644C11.698309 1.5519482 10.095491 0 8.1250391 0C6.1545858 0 4.5517688 1.5519482 4.5517688 3.4598644L4.5517688 10.986903L3.6094954 11.899272C3.5438757 11.600026 3.5072362 11.290358 3.5072362 10.972472L3.5072362 9.563633C3.5072362 9.3423557 3.3217626 9.1627684 3.0932322 9.1627684L2.3817661 9.1627684C2.1532357 9.1627684 1.9677618 9.3423557 1.9677618 9.563633L1.9677618 10.972472C1.9677618 11.708059 2.1180453 12.420998 2.3863201 13.083627L0.33348036 15.071115C-0.11116012 15.501643 -0.11116012 16.199749 0.33348036 16.630278C0.55559361 16.845343 0.84705251 16.952974 1.1385114 16.952974C1.4299704 16.952974 1.7212223 16.845343 1.9435426 16.630278L15.916183 3.1010904C16.361238 2.6705616 16.361238 1.9726559 15.91639 1.542127Z"
      />
    </svg>
  );
};

export default MuteIcon;
